export const useScripts = () => {
  const { acceptedAnalytics, acceptedAds } = useConsent()
  const { isLoggedIn } = toRefs(useUser())
  const { proxy: clarityProxy } = useClarity()
  // useGtm()
  const { proxy: metaPixelProxy } = useMetaPixel()
  const { proxy: ga4Proxy } = useGA4()
  const { proxy: smartsuppProxy } = useSmartsupp()
  // const { proxy: pinterestProxy } = usePinterestTag()

  const { locale } = useI18n()

  const {
    public: { ga4Id },
  } = useRuntimeConfig()

  ga4Proxy.gtag('config', ga4Id, {
    send_page_view: false,
  })

  watch(
    locale,
    (newLocale) => {
      if (newLocale === 'cs') {
        smartsuppProxy.smartsupp('chat:show')
      } else {
        smartsuppProxy.smartsupp('chat:hide')
      }
    },
    { immediate: true }
  )

  useScriptEventPage(({ title, path }) => {
    metaPixelProxy.fbq('track', 'ViewContent', {
      content_name: title,
      content_category: 'page',
      content_ids: [path],
    })

    ga4Proxy.gtag('event', 'page_view', {
      page_title: title,
      page_location: path,
    })

    // pinterestProxy.pintrk('page')
  })

  function acceptAnalytics() {
    clarityProxy.clarity('consent')
    // TODO: Remove when https://github.com/nuxt/scripts/issues/442 is solved
    if (window && window.clarity) {
      window.clarity('consent')
    }

    ga4Proxy.gtag('consent', 'update', {
      analytics_storage: 'granted',
    })

    // pinterestProxy.pintrk('setconsent', true)
  }

  function declineAnalytics() {
    clarityProxy.clarity('consent', false)
    // TODO: Remove when https://github.com/nuxt/scripts/issues/442 is solved
    if (window && window.clarity) {
      window.clarity('consent', false)
    }

    ga4Proxy.gtag('consent', 'update', {
      analytics_storage: 'denied',
    })

    // pinterestProxy.pintrk('setconsent', false)
  }

  watch(
    [acceptedAnalytics, isLoggedIn],
    async ([accepted, loggedIn]) => {
      if (accepted || loggedIn) {
        acceptAnalytics()
      } else {
        declineAnalytics()
      }
    },
    { immediate: true }
  )

  watch([acceptedAds, isLoggedIn], async ([accepted, loggedIn]) => {
    if (accepted || loggedIn) {
      ga4Proxy.gtag('consent', 'update', {
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted',
      })
    } else {
      ga4Proxy.gtag('consent', 'update', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      })
    }
  })
}
